export default __webpack_public_path__ + "static/marcus@2x-1421500f519b5a6dc72970b12f2d90a2.png";